(() => {
  if (window.slMotionReady) return;
  window.slMotionReady = true;

  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!root.classList.contains('sl-motion')) return;

  reduce.addEventListener('change', (event) => {
    root.classList.toggle('sl-motion', !event.matches);
  });

  const allowed = () => root.classList.contains('sl-motion');

  /* Scroll reveal */

  const REVEAL = [
    'main .sl-section .sl-heading',
    'main .sl-section .sl-heading__row > .sl-text-link',
    'main .sl-section ul[role="list"]:not([data-sl-scroller-track]) > li',
    'main .sl-section .sl-faq__item',
    'main .sl-section .sl-media',
    'main .sl-section .sl-body',
    'main .sl-section .sl-lede',
    'main .sl-section .sl-actions',
    'main .sl-section .sl-closing__mark',
    'main .sl-section table',
  ].join(',');
  const STAGGER = 80;
  const MAX_STAGGER = 6;

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            let index = 0;
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const el = entry.target;
              el.style.setProperty('--sl-reveal-delay', `${Math.min(index, MAX_STAGGER) * STAGGER}ms`);
              el.classList.add('is-in');
              observer.unobserve(el);
              index += 1;
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        )
      : null;

  const scan = (scope) => {
    if (!observer || !allowed() || (window.Shopify && window.Shopify.designMode)) return;
    const targets = [];
    scope.querySelectorAll(REVEAL).forEach((el) => {
      if (el.classList.contains('sl-reveal')) return;
      if (el.closest('.sl-hero, .sl-page-hero')) return;
      if (targets.some((parent) => parent.contains(el))) return;
      targets.push(el);
    });
    targets.forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
      el.classList.add('sl-reveal');
      observer.observe(el);
    });
  };

  const start = () => scan(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));

  /* Accordions: animate the height of native details elements. */

  const ACCORDION = 'details.sl-faq__item, details.sl-header__drawer-group';
  const OPEN_MS = 360;
  const CLOSE_MS = 260;
  const EASE = 'cubic-bezier(0.2, 0, 0, 1)';

  const finish = (details) => {
    details.style.height = '';
    details.style.overflow = '';
    details.classList.remove('is-closing');
    details.slAnimation = null;
  };

  const toggle = (details) => {
    const from = details.offsetHeight;
    if (details.slAnimation) details.slAnimation.cancel();

    const closing = details.open && !details.classList.contains('is-closing');
    let to;
    if (closing) {
      details.open = false;
      to = details.offsetHeight;
      details.open = true;
      details.classList.add('is-closing');
    } else {
      details.classList.remove('is-closing');
      details.open = true;
      details.style.height = '';
      to = details.offsetHeight;
    }

    details.style.overflow = 'hidden';
    const animation = details.animate(
      { height: [`${from}px`, `${to}px`] },
      { duration: closing ? CLOSE_MS : OPEN_MS, easing: EASE }
    );
    details.slAnimation = animation;
    animation.onfinish = () => {
      if (closing) details.open = false;
      finish(details);
    };
    animation.oncancel = () => {
      details.style.height = '';
    };
  };

  document.addEventListener('click', (event) => {
    if (!allowed()) return;
    const summary = event.target.closest('summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details || !details.matches(ACCORDION) || typeof details.animate !== 'function') return;
    event.preventDefault();
    toggle(details);
  });

  /* Mobile menu: let the drawer fade out before it closes. */

  document.addEventListener('click', (event) => {
    if (!allowed()) return;
    const toggleButton = event.target.closest('.sl-header__toggle');
    if (!toggleButton) return;
    const menu = toggleButton.closest('[data-sl-header-menu]');
    if (!menu || !menu.open || menu.classList.contains('is-closing')) return;
    const drawer = menu.querySelector('.sl-header__drawer');
    if (!drawer) return;
    event.preventDefault();
    menu.classList.add('is-closing');
    let done = false;
    const close = () => {
      if (done) return;
      done = true;
      menu.classList.remove('is-closing');
      menu.removeAttribute('open');
    };
    const onEnd = (animationEvent) => {
      if (animationEvent.target !== drawer) return;
      drawer.removeEventListener('animationend', onEnd);
      close();
    };
    drawer.addEventListener('animationend', onEnd);
    setTimeout(() => {
      drawer.removeEventListener('animationend', onEnd);
      close();
    }, 320);
  });
})();
